document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth > 768) {
		for (item of document.querySelectorAll('.video_inner > div'))
		item.style.scrollSnapAlign = 'center';

		const videogallery = document.querySelectorAll('.insta-slider');
		videogallery.forEach(btn => {
			const videogallery_scroller = btn.querySelector('.video_inner');
			const videogallery_item_size = videogallery_scroller.querySelector('div').clientWidth;
			
			btn.querySelector('.btn.next').addEventListener('click', scrollToNextPage);
			btn.querySelector('.btn.prev').addEventListener('click', scrollToPrevPage);
			
			function scrollToNextPage() {
				videogallery_scroller.scrollBy(videogallery_item_size, 0);
			}
			function scrollToPrevPage() {
				videogallery_scroller.scrollBy(-videogallery_item_size, 0);
			}
		});
		
	}

  window.addEventListener('load', function() {
      const iframes = document.querySelectorAll('.instagram-media.instagram-media-rendered');
      
      iframes.forEach(iframe => {
        iframe.style.minWidth = '1px';
        iframe.style.maxWidth = '100%';
      });
  });
});


